<template>
  <div class="Shape" v-bind:style="{ marginTop: marginTopPos }">
    <v-row>
      <v-col>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d365.4474169336909!2d106.82594695640526!3d-6.245290367198405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3da54eb19a3%3A0xdf0d7ea8fc46a182!2sMutiara%20Building%2C%20RT.3%2FRW.5%2C%20Mampang%20Prpt.%2C%20Kec.%20Mampang%20Prpt.%2C%20Kota%20Jakarta%20Selatan%2C%20Daerah%20Khusus%20Ibukota%20Jakarta%2012790!5e0!3m2!1sen!2sid!4v1779339729244!5m2!1sen!2sid"
          width="100%"
          height="100%"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </v-col>
      <v-col>
        <p class="title-1">Send us a Message</p>
        <v-row>
          <v-col>
            <div class="Indosurya-Plaza-Penthouse-Floor-Jalan-MH-Thamri">
              <div>PT Indo Fin Tek</div>
              <div>
                Gedung Mutiara Building Lt. 2 - Unit 205
                Jl. Mampang Prapatan Raya No. 10
                Jakarta Selatan, DKI Jakarta 12790
              </div>
            </div>
          </v-col>
          <v-col>
            <p class="e-mail">hello@dompetkilat.co.id</p>
            <p class="no-telp">(021) 3193-4699</p>
          </v-col>
        </v-row>
        <div class="Name-Input">
          <p class="Name-Title">Your Name</p>
          <v-text-field
            class="input-field"
            style="width: 442px"
            v-model="name"
            placeholder="Nama Anda"
          />
        </div>
        <div class="Email-Input">
          <p class="Name-Title">Email Address</p>
          <v-text-field
            class="input-field"
            v-model="email"
            placeholder="Email Anda"
          />
        </div>
        <div class="Message-Input">
          <p class="Name-Title">Message</p>
          <v-textarea
            rows="3"
            class="input-field"
            v-model="message"
            placeholder="Halo..."
          />
        </div>
        <v-btn
          @click="kirimpesan()"
          color="black"
          rounded
          block
          dark
          class="Shape-Button-Text"
          ><p style="margin: 0px">Kirim Pesan</p></v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      message: "",
      marginTopPos: "-" + window.innerWidth / 10 + "px",
    };
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  methods: {
    kirimpesan() {
      console.log("selesai");
    },
    myEventHandler() {
      this.marginTopPos = "-" + window.innerWidth / 10 + "px";
    },
  },
};
</script>
<style scoped>
.Shape {
  width: 895px;
  height: 524px;
  margin: -793px auto 0px auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  position: relative;
}
.title-1 {
  width: 175px;
  height: 24px;
  flex-grow: 0;
  margin: 0 8px 12px 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Indosurya-Plaza-Penthouse-Floor-Jalan-MH-Thamri {
  width: 163px;
  height: 80px;
  flex-grow: 0;
  margin: 12px 20px 100px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: 0.28px;
  text-align: left;
  color: #767676;
}
.e-mail {
  width: 159px;
  height: 21px;
  flex-grow: 0;
  margin: 12px 0 8px 8px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.26px;
  text-align: left;
  color: #767676;
}
.no-telp {
  width: 159px;
  height: 21px;
  flex-grow: 0;
  margin: 8px 0 44px 8px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.26px;
  text-align: left;
  color: #767676;
}
.input {
  width: 109px;
  height: 17px;
  flex-grow: 0;
  margin: 8px 233px 13px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Name-Title {
  width: 109px;
  height: 16px;
  flex-grow: 0;
  margin: 0 273px 8px 0;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #b5b5b5;
}
.Name-Input {
  width: 400px;
  height: 55px;
  flex-grow: 0;
  margin: 8px 0;
}
.Email-Input {
  width: 400px;
  height: 55px;
  flex-grow: 0;
  margin: 20px 0;
}
.Message-Input {
  width: 400px;
  height: 106px;
  flex-grow: 0;
  margin: 20px 0 44px;
}
.Shape-Button {
  width: 342px;
  height: 44px;
  flex-grow: 0;
  margin-top: -10px;
  padding: 14px 133px;
  border-radius: 40px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  background-color: #252525;
}
.Shape-Button-Text {
  flex-grow: 0;
  font-family: Inter;
  margin-top: -30px;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.input-field {
  flex-grow: 0;
  padding-top: 0px;
  margin: 0px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
</style>
